import { StudentDocument } from 'src/app/shared/interfaces/student-document';

export interface DashboardResponse {
  caseStage?: string;
  firstName: string;
  lastName: string;
  nycid?: string;
  studentSK: string;
  referralSK?: string;
  dob: Date | string;
  evaluationSite?: string;
  activity?: string;
  prevActivity?: string;
  dueDate?: string;
  complianceDate?: Date | string;
  totalCount?: number;
  district?: string;
  dbn?: string;
  caseProcess?: string;
  compliancedays?: number;
  complianceStatus?: string;
  referralStatus?: any;
  evalStatus?: any;
  iepStatus?: any;
  placementStatus?: any;
  referralColor?: string;
  evalColor?: string;
  iepColor?: string;
  placementColor?: string;
  complianceDates?: string;
  dueDates?: string;
  timeline?: string[];
  personSK?: string;
  assigned?: boolean;
  schoolLocation?: string;
  caseAssdFirstName?: string;
  caseAssdLastName?: string;
  caseAssdEmail?: string;
  caseAssdRole?: string;
  eiid?: string;
  hasCompensatoryServices?: boolean;

  rfd?: boolean;
  age?: number; // This isn't returned from the API, but is calculated in the UI
  isExpand?: boolean; // This isn't returned from the API, but is used in the UI
  cseDistrict?: string;
  cse?: string;
  resident?: boolean;
  nycId?: string;
  isPreSchool?: boolean;
}

export interface DashboardIEPResponse {
  iepDocumentType?: string;
  planItem?: string;
  iepDocumentStatus?: string;
  iepMeetingStatus?: string;
  iepFinalizationDate?: string;
  disabilityClassification?: string;
  hasTransportationNeeds?: string;
  programServices?: IEPResponse;
}

export interface IEPResponse {
  iepSk: string;
  studentSK?: string;
  programs: Mandate[];
  relatedServices: Mandate[];
  transportation: Record[];
  assistiveTechnology: Record[];
  assistiveTech: Mandate[];
  supportForSchoolPersonnel: Mandate[];
  supplementaryAids: Mandate[];
  iepTeam: IEPPeople[];
  providers: IEPPeople[];
  medicalCondition?: boolean;
  physicalLimitation?: boolean;
  affectLearning?: boolean;
  affectBehavior?: boolean;
  requireMedicalCare?: boolean;
  isLearning?: boolean;
  isBehavior?: boolean;
  medicalcare?: boolean;
  healthCare?: boolean;
  transportationDesc?: string;
  ambulatoryDesc?: string;
  annualRevDate?: Date;
  classification?: string;
  placementRecommendations?: string;
  referralSK?: string;
  nycid?: string;
  extensionDate?: Date;
  mandated3YearDate?: Date;
  document: Uint8Array[];
  seitAgency?: string;
  isPALAvailable?: boolean;
  iepFinalisedDate?: Date;
  typeOfMeeting?: number;
  isPlacementAddedForCurrentService?: boolean;
  isDep1Enable?: boolean;
}

export interface Mandate {
  mandateSk?: string;
  mandateType?: string;
  mandateDescription?: string;
  frequency?: string;
  language?: string;
  groupType?: string;
  isTwelveMonth?: boolean;
  isCompensatory?: boolean;
  duration?: string;
  firstAttendDate?: Date;
  iepFormsk?: string;
  groupTypeOther: string;
  period: string;
  ratio: string;
  location: string;
  locationOther: string;
  serviceStartDate?: Date;
  serviceEndDate?: Date;
  groupSize: string;
  serviceType: string;
  goalSeq: number[];
  classroomsetting: number;
  serviceDeliveryrec: string;
  authorizationDate?: Date; // Not returned from the API but used in the UI
  mandateShortDescription?: string;
  assignmentStatus?: string;
  assignmentSubStatus?: string;
  providerFullName?: string;
  assignmentStartDate?: string;
  assignmentEndDate?: string;
  firstEncounterDate?: string;
  isSplit?: boolean;
  splitMandateAssignment: AssignmentSplitInfo[];
 isPlacementAddedForCurrentService: boolean
}
export interface AssignmentSplitInfo {
  splitNo?: number;
  mandateShortDescription?: string;
  assignmentStatus?: string;
  assignmentSubStatus?: string;
  providerFullName?: string;
  assignmentStartDate?: Date;
  assignmentEndDate?: Date;
  firstEncounterDate?: Date;
  firstAttendDate?: Date;
  splitFrequency?: string;
  splitDuration?: number;
  providerSk?: string;
}

export interface Record {
  title: string;
  description: string;
}

export interface IEPPeople {
  name?: string;
  role?: string;
  task?: string;
  taskStatus?: string;
}

export interface DashboardEvalResponse {
  shmDate?: string;
  shpStatus?: string;
  consentIEGiven?: string;
  evaluationList?: EvaluationList[];
}

export interface EvaluationList {
  evaluationSk?: string;
  evaluationName?: string;
  evaluationStatus?: string;
  evaluatorType?: string;
  evaluatorName?: string;
  providerSk?: string;
  dueDate?: string;
  agencySk?: string;
  agencyName?: string;
}

export interface DashboardPlacementItem {
  caseActionSk?: string;
  canRescind?: boolean;
  isSummer?: boolean;
  fullSchoolName?: string;
  schoolDBN?: string;
  buildingCode?: string;
  schoolName?: string;
  district?: string;
  grade?: string;
  class?: string;
  schoolYear?: string;
  placementType?: string;
  schoolAddressLine1?: string;
  schoolAddressLine2?: string;
  schoolCity?: string;
  schoolState?: string;
  schoolZip?: string;
}

export interface DashboardPlacementStatus {
  canRescind?: boolean;
  caseActionSk?: string;
  iepType?: string;
  iepMeetingDate?: string;
  iepPlacementRecommendation?: string;
  fullSchoolName?: string;
  buildingCode?: string;
  schoolDBN?: string;
  schoolName?: string;
  placementType?: string;
  schoolYear?: string;
  class?: string;
  district?: string;
  grade?: string;
  placements?: DashboardPlacementItem[];
}

export interface DashboardReferralResponse {
  type?: string;
  processStep?: string;
  dates?: string[];
  additionalInfo?: string;
}

export interface PlacementRescindRequest {
  studentSk: string;
  placementSk: string;
  program: string;
  placementType: '10' | '12';
  rescindReasonSk: number;
}

export interface PlacementRescindResponse {
  placementRescindSk: string;
  placementSk: string;
  rescindReasonSk: number;
  additionalInformation: string;
  createdTs: string;
  lastModuser: string;
  lastModTs: string;
}

export interface RescindPlacementPayload {
  requests: PlacementRescindRequest[];
  rescindReasonSk: number;
  documents?: StudentDocument[];
  selectedFiles?: File[];
}

export interface HeaderResponse {
  caseStage?: string;
  firstName: string;
  lastName: string;
  nycID: string;
  studentSK: string;
  referralSK?: string;
  dob: string;
  evaluationSite?: string;
  activity?: string;
  prevActivity?: string;
  district?: string;
  dbn?: string;
  caseProcess?: string;
  complianceStatus?: string;
  referralStatus?: string;
  evalStatus?: string;
  iepStatus?: string;
  placementStatus?: string;
  caseStatus?: string;
  referralColor?: string;
  evalColor?: string;
  iepColor?: string;
  placementColor?: string;
  complianceDates?: string;
  dueDates?: string;
  personSK?: string;
  assigned?: boolean;
  caseAssdFirstName?: string;
  caseAssdLastName?: string;
  caseAssdEmail?: string;
  caseAssdRole?: string;
  studentStatus?: string;
  caseCloseDate?: string;
  reasonforCaseclose?: number;
  reasonforCasecloseDesc?: string;
  noOfClosures: number;
  nycid?: string;
  timeline?: string[];
  complianceDate?: string;
  school?: string;
  grade?: string;
  hasKIP?: boolean;
  eiId?: string;
  gradeValue?: string;
}

export enum StudentSectionType {
  Programs = 'Programs',
  RelatedServices = 'RelatedServices',
  AssistiveTechnology = 'AssistiveTechnology',
  SupplementaryAids = 'SupplementaryAids',
  Supports = 'Supports',
}
